import React, { useCallback, useEffect, useState } from 'react';
import { Modal, ModalFooter, TabContent, TabPane } from 'reactstrap';
import { FiX } from 'react-icons/fi';
import { ReactComponent as WarningIcon } from '~/assets/img/warning.svg';
import { useOrder } from '~/context/orderContext';
import CardOrdersAndamento from '~/components/Orders/Cards/CardOrdersAndamento';
import { ReactComponent as LiveOn } from '~/assets/img/live_on.svg';
import { ReactComponent as LiveOff } from '~/assets/img/live_off.svg';
import CardOrdersNew from '~/components/Orders/Cards/CardOrdersNew';
import CardOrdersCanceled from '~/components/Orders/Cards/CardOrdersCanceled';
import CardOrdersReady from '~/components/Orders/Cards/CardOrdersReady';
import CardOrdersFinishedDelivery from '~/components/Orders/Cards/CardOrderFinishedDelivery';
import CardOrdersDelivery from '~/components/Orders/Cards/CardOrdersDelivery';
import { useMotoboys } from '~/context/MotoboysContext';
import { useAuth } from '~/context/AuthContext';
import CardOrdersSchedulingNew from '~/components/Orders/Cards/CardOrdersSchedulingNew';
import CardOrdersSchedulingReady from '~/components/Orders/Cards/CardOrdersSchedulingReady';
import CardOrdersSchedulingAndamento from '~/components/Orders/Cards/CardOrdersSchedulingAndamento';
import { VideoPlayer } from '~/components/VideoPlayer';
import { Button, Hyperlink, Tabs } from 'ui-kit-takeat';
import { FaCopy } from 'react-icons/fa';
import { toast } from 'react-hot-toast';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { MdUpdate } from 'react-icons/md';
import { FaMagnifyingGlass, FaX, FaGear } from 'react-icons/fa6';
import { getDay, getHours, getMinutes } from 'date-fns';
import Warning from '~/components/Notify';
import { ReactComponent as LiveIcon } from '~/assets/img/liveIcon.svg';
import {
  Button as ButtonUi,
  CalendarDateFuture,
  Checkbox,
  Dropdown,
  IconClose,
  IconCloseCircleFilled,
  IconDownload,
  IconExchange,
  IconFilterList,
  IconRefresh,
  IconSearch,
  IconSettingsFilled,
  Input,
} from 'takeat-design-system-ui-kit';
import { size } from 'polished';
import BannerErrorWpp from '~/assets/img/erroWpp.jpeg';
import {
  Wrapper,
  Header,
  LugarPedidos,
  DeliveryLink,
  LinkAndVideoDiv,
  LiveTextContent,
  SquareButton,
  SearchInput,
  LinkStyled,
  FilterArea,
  DropdownItem,
} from './styles';
import api from '~/services/api';
import { generateSheet } from '~/services/SheetGenerate/generateScheduled';
import FileSaver from 'file-saver';
import WappAlertDrawer from 'components/WppAlertDrawer';
import WppAlertButton from 'components/WppAlertDrawer/button';
import useWhatsappStore from 'store/whatsappStore';

function OrdersPage({
  handleItemFinished,
  handleCancelItem,
  handleItemReady,
  handlePrintItem,
  setItemIfoodId,
  wppAlert,
}) {
  const { planType } = useWhatsappStore();
  const [activeTab, setActiveTab] = useState(0);
  const {
    pendingBaskets,
    acceptedBaskets,
    finishedBaskets,
    canceledBaskets,
    readyBaskets,
    ongoingBaskets,
    deliveredBaskets,
    loading,
    getAllOrders,
    handleSetOrderBy,
    handleVerifyOrderBy,
    orderBy,
    channelType,
    handleSetChannelType,
    handleVerifyChecked,
  } = useOrder();
  const {
    user,
    paymentMethodsState,
    shouldFetchBaskets,
    setShouldFetchBaskets,
  } = useAuth();
  const history = useHistory();
  const secondPath = history.location.pathname.split('/')[2];

  const [hasOrder, setHasOrder] = useState(true);
  const [hasSchedulingOrder, setHasSchedulingOrder] = useState(true);
  const [filter, setFilter] = useState('');
  const [visiblefilter, setVisibleFilter] = useState('');
  const [pendingBasketsCount, setPendingBasketsCount] = useState(0);
  const [acceptedBasketsCount, setAcceptedBasketsCount] = useState(0);
  const [readyBasketsCount, setReadyBasketsCount] = useState(0);
  const [pendingBasketSchedulingCount, setPendingBasketSchedulingCount] =
    useState(0);
  const [acceptedBasketSchedulingCount, setAcceptedBasketSchedulingCount] =
    useState(0);
  const [readyBasketSchedulingCount, setReadyBasketSchedulingCount] =
    useState(0);
  const [canceledBasketsCount, setCanceledBasketsCount] = useState(0);

  const getScheduled = async () => {
    try {
      const data = await api.get('/restaurants/table-sessions-scheduled');

      const sheet = await generateSheet(data);
      const uint = new Uint8Array(sheet);
      const blob = new Blob([uint], {
        type: 'application/xlsx',
      });

      FileSaver.saveAs(blob, `Agendamentos.xlsx`);

      return data;
    } catch (error) {
      console.log(error);
      toast.error('Erro ao gerar planilha de agendamentos');
    }
  };

  useEffect(() => {
    const count_orders_new = pendingBaskets.filter(
      (order) => order.table.table_type === 'delivery' && !order.scheduled_to
    ).length; // cards new order e esse

    const count_orders_accepted = acceptedBaskets.filter(
      (order) => order.table.table_type === 'delivery' && !order.scheduled_to
    ).length; // accepted

    const count_orders_ready = readyBaskets.filter(
      (order) => order.table.table_type === 'delivery' && !order.scheduled_to
    ).length;

    const count_orders_scheduling_new = pendingBaskets.filter(
      (order) => order.table.table_type === 'delivery' && order.scheduled_to
    ).length;

    const count_orders_scheduling_accepted = acceptedBaskets.filter(
      (order) => order.table.table_type === 'delivery' && order.scheduled_to
    ).length;

    const count_orders_scheduling_ready = readyBaskets.filter(
      (order) => order.table.table_type === 'delivery' && order.scheduled_to
    ).length;

    const count_orders_canceled = canceledBaskets.filter(
      (order) => order.table.table_type === 'delivery'
    ).length;

    setPendingBasketsCount(count_orders_new);
    setAcceptedBasketsCount(count_orders_accepted);
    setReadyBasketsCount(count_orders_ready);

    setPendingBasketSchedulingCount(count_orders_scheduling_new);
    setAcceptedBasketSchedulingCount(count_orders_scheduling_accepted);
    setReadyBasketSchedulingCount(count_orders_scheduling_ready);

    setCanceledBasketsCount(count_orders_canceled);

    setHasOrder(
      count_orders_new > 0 ||
      count_orders_accepted > 0 ||
      count_orders_ready > 0
    );

    setHasSchedulingOrder(
      count_orders_scheduling_new > 0 ||
      count_orders_scheduling_accepted > 0 ||
      count_orders_scheduling_ready > 0
    );
  }, [acceptedBaskets, readyBaskets, pendingBaskets]);

  const { getMotoboys } = useMotoboys();

  async function handleUpdate() {
    getAllOrders();
    setSelectedDate({
      start: null,
      end: null,
    });
  }

  useEffect(() => {
    if (user.delivery_info.is_delivery_allowed) {
      getMotoboys();
    }
  }, [getMotoboys]);

  // live conditional
  const [isLiveOn, setIsLiveOn] = useState(() => {
    const now = new Date();
    const day = getDay(now);
    const hour = getHours(now);

    // Verifica se é dia útil (segunda a sexta)
    const isWeekday = day >= 1 && day <= 5;

    // Verifica se está no horário comercial
    const isMorning = hour >= 9 && hour < 12;
    const isAfternoon = hour >= 14 && hour < 18;

    return isWeekday && (isMorning || isAfternoon);
  });

  const [isLiveTextContextOpened, setIsLiveTextContextOpened] = useState(false);

  function toggleLiveTextContext() {
    setIsLiveTextContextOpened(!isLiveTextContextOpened);
  }

  function handleGoToLive() {
    window.open('https://meet.google.com/wqr-yurp-jed');
  }

  const handleSearchCommand = (arrayToFilter, filterString) => {
    const filteredArray = arrayToFilter.filter((basket) => {
      const searchString = filterString.toLowerCase();
      for (const key in basket) {
        if (basket.hasOwnProperty(key)) {
          if (
            key === 'attendance_password' &&
            basket[key] !== null &&
            basket[key].toString().startsWith(searchString)
          ) {
            return true;
          }
          if (
            key === 'buyer' &&
            basket[key] !== null &&
            basket[key].hasOwnProperty('name') &&
            basket[key].name?.toLowerCase().startsWith(searchString)
          ) {
            return true;
          }
          if (
            key === 'buyer' &&
            basket[key] !== null &&
            basket[key].hasOwnProperty('phone') &&
            basket[key].phone?.includes(' ') &&
            basket[key].phone?.split(' ')[1].startsWith(searchString)
          ) {
            return true;
          }
          if (
            key === 'buyer' &&
            basket[key] !== null &&
            basket[key].hasOwnProperty('phone') &&
            basket[key].phone?.includes('-') &&
            basket[key].phone?.split('-')[1].startsWith(searchString)
          ) {
            return true;
          }
          if (
            key === 'buyer' &&
            basket[key] !== null &&
            basket[key].hasOwnProperty('phone') &&
            basket[key].phone
              ?.replace(/[\s\-\(\)]/g, '')
              .startsWith(searchString)
          ) {
            return true;
          }
          if (
            key === 'buyer' &&
            basket[key] !== null &&
            basket[key].hasOwnProperty('ifood_phone') &&
            basket[key].ifood_phone?.replace(/\s/g, '').startsWith(searchString)
          ) {
            return true;
          }
          if (
            key === 'buyer' &&
            basket[key] !== null &&
            basket[key].hasOwnProperty('ifood_phone') &&
            basket[key].ifood_phone?.startsWith(searchString)
          ) {
            return true;
          }
        }
      }
      return false;
    });

    const orders = filteredArray
      .map((item) => {
        if (item?.sales_channel === 'IFOOD') {
          return {
            ...item,
            personal_channel: 'ifood',
          };
        }

        if (item?.sales_channel === '99FOOD') {
          return {
            ...item,
            personal_channel: '99food',
          };
        }

        if (item?.sales_channel === 'NEEMO') {
          return {
            ...item,
            personal_channel: 'neemo',
          };
        }

        if (item?.sales_channel === 'TAKEAT' && item.with_withdrawal) {
          return {
            ...item,
            personal_channel: 'withdrawal',
          };
        }

        if (item?.sales_channel === 'TAKEAT' && !item.with_withdrawal) {
          return {
            ...item,
            personal_channel: 'delivery',
          };
        }

        if (item.status === 'completed' && !item.with_withdrawal) {
          return {
            ...item,
            personal_channel: 'delivery',
            basket: {
              start_time: item?.start_time,
            },
          };
        }

        if (item.status === 'completed' && item.with_withdrawal) {
          return {
            ...item,
            personal_channel: 'withdrawal',
            basket: {
              start_time: item?.start_time,
            },
          };
        }

        return {
          ...item,
          personal_channel: 'neemo',
        };
      })
      .filter((a) => channelType.includes(a?.personal_channel));

    const ordersSorted =
      orders &&
      [...orders].sort((a, b) => {
        if (orderBy.includes('neighborhood')) {
          const neighborhoodA = a.buyer?.delivery_address?.neighborhood || '';
          const neighborhoodB = b.buyer?.delivery_address?.neighborhood || '';
          const compareNeighborhoods =
            neighborhoodA.localeCompare(neighborhoodB);
          if (compareNeighborhoods !== 0) return compareNeighborhoods;
        }

        if (orderBy.includes('oldest')) {
          return (
            new Date(a.basket?.start_time) - new Date(b.basket?.start_time)
          );
        }

        return new Date(b.basket?.start_time) - new Date(a.basket?.start_time);
      });

    return ordersSorted;
  };

  const [pendingBasketsFiltered, setPendingBasketsFiltered] = useState([]);
  const [acceptedBasketsFiltered, setAcceptedBasketsFiltered] = useState([]);
  const [readyBasketsFiltered, setReadyBasketsFiltered] = useState([]);
  const [
    pendingBasketsSchedulingFiltered,
    setPendingBasketsSchedulingFiltered,
  ] = useState([]);
  const [
    acceptedBasketsSchedulingFiltered,
    setAcceptedBasketsSchedulingFiltered,
  ] = useState([]);
  const [readyBasketsSchedulingFiltered, setReadyBasketsSchedulingFiltered] =
    useState([]);

  const [
    ongoingBasketsSchedulingFiltered,
    setOngoingBasketsSchedulingFiltered,
  ] = useState([]);
  const [
    deliveredBasketsSchedulingFiltered,
    setDeliveredBasketsSchedulingFiltered,
  ] = useState([]);

  const [canceledBasketsFiltered, setCanceledBasketsFiltered] = useState([]);

  const [ongoingBasketsFiltered, setOngoingBasketsFiltered] = useState([]);
  const [deliveredBasketsFiltered, setDeliveredBasketsFiltered] = useState([]);

  const [finishedBasketsFiltered, setFinishedBasketsFiltered] = useState([]);
  const [finishedBasketsSession, setFinishedBasketsSession] = useState([]);
  const [finishedBasketsSessionCounter, setFinishedBasketsSessionCounter] =
    useState(0);

  useEffect(() => {
    const finished_baskets_counter = finishedBasketsSession.length;

    setFinishedBasketsSessionCounter(finished_baskets_counter);
  }, [finishedBasketsSession]);

  useEffect(() => {
    const deliveryReadyBaskets = readyBaskets.filter(
      (order) => order.table.table_type === 'delivery' && !order.scheduled_to
    );
    const deliveryPendingBaskets = pendingBaskets.filter(
      (order) => order.table.table_type === 'delivery' && !order.scheduled_to
    );
    const deliveryAcceptedBaskets = acceptedBaskets.filter(
      (order) => order.table.table_type === 'delivery' && !order.scheduled_to
    );
    const deliveryOngoingBaskets = ongoingBaskets.filter(
      (order) => order.table.table_type === 'delivery' && !order.scheduled_to
    );
    const deliveryDeliveredBaskets = deliveredBaskets.filter(
      (order) => order.table.table_type === 'delivery' && !order.scheduled_to
    );

    const deliveryReadySchedulingBaskets =
      !selectedDate?.start || !selectedDate?.end
        ? readyBaskets.filter(
          (order) =>
            order.table.table_type === 'delivery' && order.scheduled_to
        )
        : [];
    const deliveryPendingSchedulingBaskets =
      !selectedDate?.start || !selectedDate?.end
        ? pendingBaskets.filter(
          (order) =>
            order.table.table_type === 'delivery' && order.scheduled_to
        )
        : [];
    const deliveryAcceptedSchedulingBaskets =
      !selectedDate?.start || !selectedDate?.end
        ? acceptedBaskets.filter(
          (order) =>
            order.table.table_type === 'delivery' && order.scheduled_to
        )
        : [];
    const deliveryOngoingSchedulingBaskets =
      !selectedDate?.start || !selectedDate?.end
        ? ongoingBaskets.filter(
          (order) =>
            order.table.table_type === 'delivery' && order.scheduled_to
        )
        : [];
    const deliveryDeliveredSchedulingBaskets =
      !selectedDate?.start || !selectedDate?.end
        ? deliveredBaskets.filter(
          (order) =>
            order.table.table_type === 'delivery' && order.scheduled_to
        )
        : [];
    const deliveryCanceledBaskets = canceledBaskets.filter(
      (order) => order.table.table_type === 'delivery'
    );

    const deliveryReadyBasketFiltered = handleSearchCommand(
      deliveryReadyBaskets,
      filter
    );
    const deliveryPendingBasketFiltered = handleSearchCommand(
      deliveryPendingBaskets,
      filter
    );
    const deliveryAcceptedBasketFiltered = handleSearchCommand(
      deliveryAcceptedBaskets,
      filter
    );
    const deliveryOngoingBasketFiltered = handleSearchCommand(
      deliveryOngoingBaskets,
      filter
    );
    const deliveryDeliveredBasketFiltered = handleSearchCommand(
      deliveryDeliveredBaskets,
      filter
    );

    const deliveryReadySchedulingBasketFiltered = handleSearchCommand(
      deliveryReadySchedulingBaskets,
      filter
    );
    const deliveryPendingSchedulingBasketFiltered = handleSearchCommand(
      deliveryPendingSchedulingBaskets,
      filter
    );
    const deliveryAcceptedSchedulingBasketFiltered = handleSearchCommand(
      deliveryAcceptedSchedulingBaskets,
      filter
    );
    const deliveryOngoingSchedulingBasketFiltered = handleSearchCommand(
      deliveryOngoingSchedulingBaskets,
      filter
    );
    const deliveryDeliveredSchedulingBasketFiltered = handleSearchCommand(
      deliveryDeliveredSchedulingBaskets,
      filter
    );

    const finishedBasketsFiltered = handleSearchCommand(
      finishedBasketsSession,
      filter
    );

    const deliveryCanceledBasketsFiltered = handleSearchCommand(
      deliveryCanceledBaskets,
      filter
    );

    setPendingBasketsFiltered(deliveryPendingBasketFiltered);
    setAcceptedBasketsFiltered(deliveryAcceptedBasketFiltered);
    setReadyBasketsFiltered(deliveryReadyBasketFiltered);
    setOngoingBasketsFiltered(deliveryOngoingBasketFiltered);
    setDeliveredBasketsFiltered(deliveryDeliveredBasketFiltered);

    setPendingBasketsSchedulingFiltered(
      deliveryPendingSchedulingBasketFiltered.sort(
        (a, b) => new Date(a.scheduled_to) - new Date(b.scheduled_to)
      )
    );
    setAcceptedBasketsSchedulingFiltered(
      deliveryAcceptedSchedulingBasketFiltered.sort(
        (a, b) => new Date(a.scheduled_to) - new Date(b.scheduled_to)
      )
    );
    setReadyBasketsSchedulingFiltered(
      deliveryReadySchedulingBasketFiltered.sort(
        (a, b) => new Date(a.scheduled_to) - new Date(b.scheduled_to)
      )
    );
    setOngoingBasketsSchedulingFiltered(
      deliveryOngoingSchedulingBasketFiltered.sort(
        (a, b) => new Date(a.scheduled_to) - new Date(b.scheduled_to)
      )
    );
    setDeliveredBasketsSchedulingFiltered(
      deliveryDeliveredSchedulingBasketFiltered.sort(
        (a, b) => new Date(a.scheduled_to) - new Date(b.scheduled_to)
      )
    );

    setFinishedBasketsFiltered(finishedBasketsFiltered);

    setCanceledBasketsFiltered(deliveryCanceledBasketsFiltered);
  }, [
    readyBaskets,
    pendingBaskets,
    acceptedBaskets,
    finishedBasketsSession,
    filter,
    activeTab,
    ongoingBaskets,
    deliveredBaskets,
    canceledBaskets,
    orderBy,
    channelType,
  ]);

  useEffect(() => {
    setFilter('');
    setSelectedDate({
      start: null,
      end: null,
    });
  }, [activeTab]);

  function formatFilter(filtro) {
    const formatedFilter = filtro.replace(/^0+/, '');
    setFilter(formatedFilter);
    setVisibleFilter(filtro);
  }

  const [allPaymentMethods, setAllPaymentMethods] = useState([]);
  const [favoritePaymentMethods, setFavoritePaymentMethods] = useState([]);
  const [paymentMethods, setPaymentMethods] = useState([]);

  const getPaymentMethods = useCallback(async () => {
    const methods = paymentMethodsState;

    methods.sort((a, b) => Number(b.is_favorite) - Number(a.is_favorite));

    setAllPaymentMethods([...methods]);

    const favoriteMethods = methods.slice(0, 8);

    setFavoritePaymentMethods(favoriteMethods);

    setPaymentMethods(methods.slice(8));
  }, [paymentMethodsState]);

  useEffect(() => {
    getPaymentMethods();
  }, [getPaymentMethods]);

  // warning de novidade do contas a prazo
  const warningCreditRegisterStorage = JSON.parse(
    localStorage.getItem('@gddashboard:warningCreditRegister')
  );

  const [isNotifyOpened, setIsNotifyOpened] = useState(() => {
    if (user?.credit_register_enabled) {
      if (warningCreditRegisterStorage === null) {
        return true;
      }
      return warningCreditRegisterStorage;
    }
    return false;
  });

  function handleConfirmAndCloseNotify() {
    setIsNotifyOpened(false);
    localStorage.setItem('@gddashboard:warningCreditRegister', false);
  }

  // warning da live de suporte estar online
  const [isNotifyLiveOpened, setIsNotifyLiveOpened] = useState(() => {
    const now = new Date();
    const day = getDay(now);
    const hour = getHours(now);
    const minute = getMinutes(now);

    // Verifica se é dia útil (segunda a sexta)
    const isWeekday = day >= 1 && day <= 5;

    // Verifica se está no horário comercial
    const isMorning = hour === 9 && minute === 0;
    const isAfternoon = hour === 14 && minute === 0;

    return isWeekday && (isMorning || isAfternoon);
  });

  // warning da live de suporte noturno estar online
  const [isNotifyNightLiveOpened, setIsNotifyNightLiveOpened] = useState(() => {
    const now = new Date();
    const day = getDay(now);
    const hour = getHours(now);
    const minute = getMinutes(now);

    // Verifica se é dia útil (segunda a sexta)
    const isWeekday = day >= 1 && day <= 5;

    // Verifica se está no horário comercial
    const isEvening = hour === 18 && minute === 0;

    return isWeekday && isEvening;
  });

  // waring de novidade de plantao noturno
  const warningNightLiveSupportStorage = JSON.parse(
    localStorage.getItem('@gddashboard:warningNightLiveSupport')
  );

  const [isWarningNightLiveOpened, setIsWarningNightLiveOpened] = useState(
    () => {
      if (warningNightLiveSupportStorage === null) {
        return true;
      }
      return warningNightLiveSupportStorage;
    }
  );

  function handleConfirmAndCloseNightLiveNotify() {
    setIsWarningNightLiveOpened(false);
    localStorage.setItem('@gddashboard:warningNightLiveSupport', false);
  }

  useEffect(() => {
    if (shouldFetchBaskets) {
      setShouldFetchBaskets(false);
      getAllOrders();
      toast.success('Pedidos atualizados!');
    }
  }, [shouldFetchBaskets]);

  const [isModalWppErrorOpened, setIsModalWppErrorOpened] = useState(() => {
    let rawFlag = localStorage.getItem('@gddashboard:wppErrorFlag');

    if (rawFlag === null) {
      localStorage.setItem('@gddashboard:wppErrorFlag', 'true');
      rawFlag = 'true';
    }

    const flag = rawFlag === 'true';

    const today = new Date();
    const isTodayJul28 =
      today.getDate() === 28 &&
      today.getMonth() === 6 &&
      today.getFullYear() === 2025;

    console.log('flag:', flag, 'isTodayJul28:', isTodayJul28);

    return flag && isTodayJul28;
  });

  const [selectedDate, setSelectedDate] = useState({
    start: null,
    end: null,
  });

  useEffect(() => {
    if (selectedDate.start && selectedDate.end) {
      const deliveryPendingSchedulingBasketsFilterFuture =
        pendingBaskets.filter(
          (order) =>
            order.table.table_type === 'delivery' &&
            order.scheduled_to &&
            order.scheduled_to >= selectedDate.start &&
            order.scheduled_to <= selectedDate.end
        );

      const deliveryAcceptedSchedulingBasketsFilterFuture =
        acceptedBaskets.filter(
          (order) =>
            order.table.table_type === 'delivery' &&
            order.scheduled_to &&
            order.scheduled_to >= selectedDate.start &&
            order.scheduled_to <= selectedDate.end
        );

      const deliveryReadySchedulingBasketsFilterFuture = readyBaskets.filter(
        (order) =>
          order.table.table_type === 'delivery' &&
          order.scheduled_to &&
          order.scheduled_to >= selectedDate.start &&
          order.scheduled_to <= selectedDate.end
      );

      const deliveryOngoingSchedulingBasketsFilterFuture =
        ongoingBaskets.filter(
          (order) =>
            order.table.table_type === 'delivery' &&
            order.scheduled_to &&
            order.scheduled_to >= selectedDate.start &&
            order.scheduled_to <= selectedDate.end
        );

      const deliveryDeliveredSchedulingBaskets = deliveredBaskets.filter(
        (order) =>
          order.table.table_type === 'delivery' &&
          order.scheduled_to &&
          order.scheduled_to >= selectedDate.start &&
          order.scheduled_to <= selectedDate.end
      );

      const deliveryPendingSchedulingBasketFilteredFuture = handleSearchCommand(
        deliveryPendingSchedulingBasketsFilterFuture,
        filter
      );

      const deliveryAcceptedSchedulingBasketFilteredFuture =
        handleSearchCommand(
          deliveryAcceptedSchedulingBasketsFilterFuture,
          filter
        );

      const deliveryReadySchedulingBasketFilteredFuture = handleSearchCommand(
        deliveryReadySchedulingBasketsFilterFuture,
        filter
      );

      const deliveryOngoingSchedulingBasketFilteredFuture = handleSearchCommand(
        deliveryOngoingSchedulingBasketsFilterFuture,
        filter
      );

      const deliveryDeliveredSchedulingBasketFilteredFuture =
        handleSearchCommand(deliveryDeliveredSchedulingBaskets, filter);

      setPendingBasketsSchedulingFiltered(
        deliveryPendingSchedulingBasketFilteredFuture.sort(
          (a, b) => new Date(a.scheduled_to) - new Date(b.scheduled_to)
        )
      );
      setAcceptedBasketsSchedulingFiltered(
        deliveryAcceptedSchedulingBasketFilteredFuture.sort(
          (a, b) => new Date(a.scheduled_to) - new Date(b.scheduled_to)
        )
      );

      setReadyBasketsSchedulingFiltered(
        deliveryReadySchedulingBasketFilteredFuture.sort(
          (a, b) => new Date(a.scheduled_to) - new Date(b.scheduled_to)
        )
      );

      setOngoingBasketsSchedulingFiltered(
        deliveryOngoingSchedulingBasketFilteredFuture.sort(
          (a, b) => new Date(a.scheduled_to) - new Date(b.scheduled_to)
        )
      );

      setDeliveredBasketsSchedulingFiltered(
        deliveryDeliveredSchedulingBasketFilteredFuture.sort(
          (a, b) => new Date(a.scheduled_to) - new Date(b.scheduled_to)
        )
      );
    }
  }, [
    selectedDate,
    readyBaskets,
    pendingBaskets,
    acceptedBaskets,
    finishedBasketsSession,
    filter,
    activeTab,
    ongoingBaskets,
    deliveredBaskets,
    canceledBaskets,
    orderBy,
    channelType,
  ]);

  return (
    <Wrapper isOrders={secondPath === 'orders'}>
      {user.only_delivery && (
        <>
          {/* <Warning type="live" isOpen={isWarningNightLiveOpened}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <IconNightLive style={{ width: 52 }} />
            </div>

            <div style={{ marginLeft: 16 }}>
              <p
                style={{
                  fontSize: 16,
                  fontWeight: 600,
                  color: '#222',
                }}
              >
                Plantão tira-dúvidas noturno!
              </p>
              <p
                style={{
                  fontSize: 16,
                  fontWeight: 500,
                  color: '#545454',
                }}
              >
                Para aqueles que aproveitam a noite para sanar dúvidas, teremos,
                exclusivamente de 24 a 28 de março, o plantão tira-dúvidas
                noturno, das 18h às 22h! Não perca!
              </p>
            </div>
            <div style={{ width: 28 }}>
              <FaX
                onClick={() => handleConfirmAndCloseNightLiveNotify()}
                cursor="pointer"
              />
            </div>
          </Warning> */}

          {/* <Warning type="live" isOpen={isNotifyNightLiveOpened}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <LiveIcon style={{ width: 52 }} />
            </div>

            <div style={{ marginLeft: 16 }}>
              <p
                style={{
                  fontSize: 16,
                  fontWeight: 600,
                  color: '#222',
                }}
              >
                O plantão tira-dúvidas noturno acaba de começar!
              </p>
              <p
                style={{
                  fontSize: 16,
                  fontWeight: 500,
                  color: '#545454',
                }}
              >
                Ao vivo de seg a sex, das 18h às 22h, exclusivamente nesta
                semana.
              </p>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <ButtonUi customColor="#C8131B" onClick={handleGoToLive}>
                  Participar
                </ButtonUi>
              </div>
            </div>
            <div style={{ width: 28 }}>
              <FaX
                onClick={() => setIsNotifyNightLiveOpened(false)}
                cursor="pointer"
              />
            </div>
          </Warning> */}

          <Warning type="live" isOpen={isNotifyLiveOpened}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <LiveIcon style={{ width: 52 }} />
            </div>

            <div style={{ marginLeft: 16 }}>
              <p
                style={{
                  fontSize: 16,
                  fontWeight: 600,
                  color: '#222',
                }}
              >
                O plantão tira-dúvidas acaba de começar!
              </p>
              <p
                style={{
                  fontSize: 16,
                  fontWeight: 500,
                  color: '#545454',
                }}
              >
                Ao vivo de seg à sex, das 9h às 12h e 14h às 18h.
              </p>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <ButtonUi customColor="#C8131B" onClick={handleGoToLive}>
                  Participar
                </ButtonUi>
              </div>
            </div>
            <div style={{ width: 28 }}>
              <FaX
                onClick={() => setIsNotifyLiveOpened(false)}
                cursor="pointer"
              />
            </div>
          </Warning>
        </>
      )}
      {/* {user.only_delivery && (
        <Warning type="warning" isOpen={isNotifyOpened}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <WarningIcon style={{ width: 52 }} />
          </div>

          <div style={{ marginLeft: 16 }}>
            <p
              style={{
                fontSize: 16,
                fontWeight: 600,
                color: '#222',
              }}
            >
              A funcionalidade do Contas a Prazo está com novidades!
            </p>
            <span style={{ color: '#545454' }}>
              Verifique o{' '}
              <LinkStyled
                onClick={handleConfirmAndCloseNotify}
                to="/operation/credit-register"
              >
                Contas a Prazo!
              </LinkStyled>
            </span>
          </div>
          <div style={{ width: 28 }}>
            <FaX onClick={() => setIsNotifyOpened(false)} cursor="pointer" />
          </div>
        </Warning>
      )} */}
      {user.only_delivery && (
        <Modal
          isOpen={isModalWppErrorOpened}
          toggle={() => {
            setIsModalWppErrorOpened(false);
          }}
          size="lg"
        >
          <img
            src={BannerErrorWpp}
            style={{ width: '100%' }}
            alt="Banner info de erro do whatsapp"
          />

          <ModalFooter
            style={{
              padding: 10,
              justifyContent: 'flex-end',
            }}
          >
            <ButtonUi
              onClick={() => {
                setIsModalWppErrorOpened(false);
                localStorage.setItem('@gddashboard:wppErrorFlag', false);
              }}
            >
              Entendi
            </ButtonUi>
          </ModalFooter>
        </Modal>
      )}
      <Header>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            maxHeight: 65,
          }}
        >
          <LinkAndVideoDiv>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                minWidth: 426,
              }}
            >
              <DeliveryLink>
                {`Link do seu delivery: `}
                <Hyperlink
                  fontSize={14}
                  onClick={() =>
                    window.open(
                      `https://pedido.takeat.app/${user?.nickname ? user?.nickname : user?.name
                      }`
                    )
                  }
                >
                  {`https://pedido.takeat.app/${user?.nickname ? user?.nickname : user?.name
                    }`}
                </Hyperlink>
                <Hyperlink
                  onClick={() =>
                    navigator.clipboard
                      .writeText(
                        `https://pedido.takeat.app/${user?.nickname ? user?.nickname : user?.name
                        }`
                      )
                      .then(() => toast.success('Link copiado com sucesso!'))
                  }
                >
                  <FaCopy />
                </Hyperlink>
              </DeliveryLink>
              {isLiveOn ? (
                <LiveOn
                  onClick={toggleLiveTextContext}
                  style={{ cursor: 'pointer' }}
                />
              ) : (
                <LiveOff
                  onClick={toggleLiveTextContext}
                  style={{ cursor: 'pointer' }}
                />
              )}

              <div style={{ position: 'relative' }}>
                {isLiveOn && isLiveTextContextOpened ? (
                  <LiveTextContent>
                    <FaX
                      onClick={toggleLiveTextContext}
                      color="#f10d27"
                      cursor="pointer"
                      style={{ float: 'right' }}
                    />
                    {/* <p>
                      Esclarecemos as suas dúvidas em tempo real. Junte-se ao
                      nosso plantão tira dúvidas.
                    </p>

                    <p style={{ fontSize: 14, marginTop: 10 }}>
                      {' '}
                      Programação: 9h às 12h e 14h às 18h de segunda à sexta.
                    </p>

                    <Button
                      title="Ir para o plantão tira dúvidas"
                      containerStyles={{ width: '100%' }}
                      onClick={handleGoToLive}
                    /> */}
                    <p>
                      Nosso plantão tira dúvidas está temporariamente fora do ar, retornaremos assim que possível.
                    </p>
                    <Button title='Voltaremos em breve' disabled />
                  </LiveTextContent>
                ) : (
                  isLiveTextContextOpened && (
                    <LiveTextContent>
                      <FaX
                        onClick={toggleLiveTextContext}
                        color="#f10d27"
                        cursor="pointer"
                        style={{ float: 'right' }}
                      />
                      <p>
                        O plantão tira dúvidas é um atendimento coletivo, onde
                        um de nossos especialistas fica de prontidão via Google
                        Meet, com o intuito de sanar suas dúvidas quanto ao
                        sistema.
                      </p>
                      <p>
                        Estamos disponíveis de 9h às 12h e 14h às 18h de segunda
                        à sexta. Traga suas dúvidas!
                      </p>
                    </LiveTextContent>
                  )
                )}
              </div>
            </div>
          </LinkAndVideoDiv>
          <VideoPlayer
            id={67}
            containerStyles={{ marginLeft: 0, maxHeight: 45 }}
          />
        </div>
      </Header>

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Tabs
          onChangeTab={(tab) => setActiveTab(tab)}
          selected={activeTab}
          tabs={[
            'Pedidos Novos e Em Andamento',
            'Pedidos Agendados',
            'Pedidos Entregues',
            'Pedidos Cancelados',
          ]}
          counter={[
            null,
            pendingBaskets.filter((order) => order.scheduled_to).length,
            null,
            null,
          ]}
          mediaQueries={[
            {
              maxWidth: 1150,
              styles: `font-size: 12px; padding: 5px 15px;`,
            },
          ]}
        />
        {activeTab !== 3 && (
          <FilterArea>
            <SquareButton onClick={handleUpdate}>
              <IconRefresh
                style={{
                  fill: '#2ec9b7',
                  fontSize: 16,
                }}
              />
              <span style={{ color: '#2ec9b7' }}>Atualizar</span>
            </SquareButton>
            <SquareButton onClick={() => history.push('/delivery/scheduled-calendar')}>
              <svg
                viewBox="0 0 24 24"
                fill="#c8131b"
                style={{ width: 16, height: 16 }}
              >
                <path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zM5 8V6h14v2H5zm2 4h10v2H7v-2z" />
              </svg>
              <span style={{ color: '#c8131b' }}>Agenda</span>
            </SquareButton>
            {activeTab === 1 ? (
              <>
                <SquareButton onClick={getScheduled}>
                  <IconDownload style={{ fontSize: 16, fill: 'red' }} />
                  <span style={{ color: '#6C6C6C' }}>Baixar</span>
                </SquareButton>

                <SquareButton
                  onClick={() => history.push('/delivery/scheduling')}
                >
                  <IconSettingsFilled
                    style={{ fontSize: 16, fill: '#6C6C6C' }}
                  />
                  <span style={{ color: '#6C6C6C' }}>Config.</span>
                </SquareButton>
              </>
            ) : (
              <SquareButton onClick={() => history.push('/delivery/config')}>
                <IconSettingsFilled style={{ fontSize: 16, fill: '#6C6C6C' }} />
                <span style={{ color: '#6C6C6C' }}>Config.</span>
              </SquareButton>
            )}

            <div>
              <SquareButton
                id="dropdown-button"
                style={{ background: '#CC5F14', opacity: 0.5, color: '#fff' }}
              >
                <IconExchange style={{ fontSize: 16, fill: '#fff' }} />
                <span style={{ color: '#fff' }}>Ordenar</span>
              </SquareButton>
              <Dropdown anchor="dropdown-button" style={{ zIndex: 9999 }}>
                {(activeTab === 0 || activeTab === 1) && (
                  <DropdownItem>
                    <Checkbox
                      onClick={() => handleSetOrderBy('neighborhood')}
                      checked={handleVerifyOrderBy(['neighborhood'])}
                    />
                    Por Bairro
                  </DropdownItem>
                )}
                <DropdownItem>
                  <Checkbox
                    onClick={() => handleSetOrderBy('oldest')}
                    checked={handleVerifyOrderBy(['oldest'])}
                  />
                  Pedido antigo &gt; pedido novo
                </DropdownItem>
              </Dropdown>
            </div>

            <div>
              {activeTab === 1 && (
                <SquareButton width>
                  <CalendarDateFuture
                    dateLabel="Período de agendamento"
                    hideOptions={'Esse ano'}
                    onSelectDate={(date) =>
                      setSelectedDate({
                        start: date.start.toISOString(),
                        end: date.end.toISOString(),
                      })
                    }
                  />
                </SquareButton>
              )}
            </div>

            <div>
              <ButtonUi
                id="dropdown-filter-button"
                style={{
                  background: 'transparent',
                  border:
                    '1px solid var(--Takeat-Colors-Neutrals-Grey-02, #7A7A7A)',
                  color: '#7A7A7A',
                }}
              >
                <IconFilterList style={{ color: '#7A7A7A', fill: '#7a7a7a' }} />{' '}
                Filtro
              </ButtonUi>
              <Dropdown anchor="dropdown-filter-button" style={{ width: 196 }}>
                <Input
                  iconLeft={<IconSearch />}
                  iconRight={<IconClose />}
                  placeholder="Pedido"
                  value={visiblefilter}
                  onChange={(e) => {
                    formatFilter(e.target.value);
                  }}
                />
                <DropdownItem>
                  <Checkbox
                    onClick={() => handleSetChannelType('all')}
                    checked={handleVerifyChecked(['all'])}
                  />
                  Todos
                </DropdownItem>
                <DropdownItem>
                  <Checkbox
                    onClick={() => handleSetChannelType('delivery')}
                    checked={handleVerifyChecked(['delivery', 'all'])}
                  />
                  Delivery
                </DropdownItem>
                {user?.has_ifood && (
                  <DropdownItem>
                    <Checkbox
                      onClick={() => handleSetChannelType('ifood')}
                      checked={handleVerifyChecked(['ifood', 'all'])}
                    />
                    Ifood
                  </DropdownItem>
                )}
                {user?.has_99food && (
                  <DropdownItem>
                    <Checkbox
                      onClick={() => handleSetChannelType('99food')}
                      checked={handleVerifyChecked(['99food', 'all'])}
                    />
                    99Food
                  </DropdownItem>
                )}
                {user?.neemo_token && (
                  <DropdownItem>
                    <Checkbox
                      onClick={() => handleSetChannelType('neemo')}
                      checked={handleVerifyChecked(['neemo', 'all'])}
                    />
                    Neemo
                  </DropdownItem>
                )}
                <DropdownItem>
                  <Checkbox
                    onClick={() => handleSetChannelType('withdrawal')}
                    checked={handleVerifyChecked(['withdrawal', 'all'])}
                  />
                  Retirada
                </DropdownItem>
              </Dropdown>
            </div>
            {planType === 'AI_AGENTS' && (
              <WppAlertButton
                onClick={() => wppAlert?.updateOpenWppAlertList(true)}
                number={wppAlert?.uncheckedWppAlertList?.length}
              />
            )}
          </FilterArea>
        )}
      </div>

      <TabContent activeTab={activeTab}>
        <TabPane tabId={0} style={{ height: '100%' }}>
          {user.use_foody_delivery || user.delivery_info.use_all_kanbans ? (
            <LugarPedidos first>
              {((!user?.delivery_info.auto_accept &&
                !user?.ifood_auto_accept) ||
                (!user?.delivery_info.auto_accept && user?.ifood_auto_accept) ||
                (user?.delivery_info.auto_accept && !user?.ifood_auto_accept) ||
                pendingBasketsCount > 0) && (
                  <CardOrdersNew
                    handlePrintItem={handlePrintItem}
                    handleCancelItem={handleCancelItem}
                    baskets={pendingBasketsFiltered}
                    loading={loading}
                    setItemIfoodId={setItemIfoodId}
                    hasOrderActive={hasOrder}
                    user={user}
                    handleUpdate={handleUpdate}
                    countOrders={pendingBasketsFiltered.length}
                  />
                )}

              <CardOrdersAndamento
                baskets={acceptedBasketsFiltered}
                handleItemFinished={handleItemReady}
                handleCancelItem={handleCancelItem}
                loading={loading}
                handleItemReady={handleItemReady}
                handleUpdate={handleUpdate}
                hasOrderActive={hasOrder}
                countOrders={acceptedBasketsFiltered.length}
                showNewOrderButton={
                  user.delivery_info.auto_accept &&
                  user?.ifood_auto_accept &&
                  pendingBasketsCount === 0
                }
              />
              <CardOrdersDelivery
                baskets={readyBasketsFiltered}
                handleItemFinished={handleItemFinished}
                handleCancelItem={handleCancelItem}
                loading={loading}
                getAllOrders={getAllOrders}
                hasOrderActive={hasOrder}
                handleUpdate={handleUpdate}
                countOrders={readyBasketsFiltered.length}
                headerTitle="PRONTO"
                headerColor="#FF7D24"
                paymentMethods={paymentMethods}
                allPaymentMethods={allPaymentMethods}
                favoritePaymentMethods={favoritePaymentMethods}
                showFinishBills={false}
                hasOrderBy
                hasFilterBy={false}
                handleItemReady={handleItemReady}
              />
              <CardOrdersDelivery
                baskets={ongoingBasketsFiltered}
                handleItemFinished={handleItemFinished}
                handleCancelItem={handleCancelItem}
                loading={loading}
                getAllOrders={getAllOrders}
                hasOrderActive={hasOrder}
                handleUpdate={handleUpdate}
                countOrders={ongoingBasketsFiltered.length}
                headerTitle="EM ROTA"
                headerColor="#01AFFF"
                paymentMethods={paymentMethods}
                allPaymentMethods={allPaymentMethods}
                favoritePaymentMethods={favoritePaymentMethods}
                showFinishBills={false}
                hasOrderBy={false}
                hasFilterBy={false}
                handleItemReady={handleItemReady}
              />
              <CardOrdersDelivery
                baskets={deliveredBasketsFiltered}
                handleItemFinished={handleItemFinished}
                handleCancelItem={handleCancelItem}
                loading={loading}
                getAllOrders={getAllOrders}
                hasOrderActive={deliveredBasketsFiltered.length > 0}
                handleUpdate={handleUpdate}
                countOrders={deliveredBasketsFiltered.length}
                headerTitle="ENTREGUE"
                headerColor="#2EC9B7"
                paymentMethods={paymentMethods}
                allPaymentMethods={allPaymentMethods}
                favoritePaymentMethods={favoritePaymentMethods}
                showFinishBills
                hasOrderBy={false}
                hasFilterBy
                handleItemReady={handleItemReady}
              />
            </LugarPedidos>
          ) : (
            <LugarPedidos first>
              <CardOrdersNew
                handlePrintItem={handlePrintItem}
                handleCancelItem={handleCancelItem}
                baskets={pendingBasketsFiltered}
                loading={loading}
                setItemIfoodId={setItemIfoodId}
                hasOrderActive={hasOrder}
                user={user}
                handleUpdate={handleUpdate}
                countOrders={pendingBasketsFiltered.length}
              />
              <CardOrdersAndamento
                baskets={acceptedBasketsFiltered}
                handleItemFinished={handleItemReady}
                handleCancelItem={handleCancelItem}
                loading={loading}
                handleItemReady={handleItemReady}
                handleUpdate={handleUpdate}
                hasOrderActive={hasOrder}
                countOrders={acceptedBasketsFiltered.length}
              />
              <CardOrdersReady
                baskets={readyBasketsFiltered}
                handleItemFinished={handleItemFinished}
                handleCancelItem={handleCancelItem}
                loading={loading}
                getAllOrders={getAllOrders}
                hasOrderActive={hasOrder}
                handleUpdate={handleUpdate}
                countOrders={readyBasketsFiltered.length}
                paymentMethods={paymentMethods}
                allPaymentMethods={allPaymentMethods}
                favoritePaymentMethods={favoritePaymentMethods}
              />
            </LugarPedidos>
          )}
        </TabPane>

        <TabPane tabId={1} style={{ height: '100%' }}>
          {user.use_foody_delivery || user.delivery_info.use_all_kanbans ? (
            <LugarPedidos>
              <CardOrdersSchedulingNew
                handlePrintItem={handlePrintItem}
                handleCancelItem={handleCancelItem}
                baskets={pendingBasketsSchedulingFiltered}
                loading={loading}
                setItemIfoodId={setItemIfoodId}
                handleUpdate={handleUpdate}
                countOrders={pendingBasketSchedulingCount}
                hasOrderActive={hasSchedulingOrder}
              />
              <CardOrdersSchedulingAndamento
                baskets={acceptedBasketsSchedulingFiltered}
                handleItemFinished={handleItemReady}
                handleCancelItem={handleCancelItem}
                loading={loading}
                handleItemReady={handleItemReady}
                handleUpdate={handleUpdate}
                countOrders={acceptedBasketSchedulingCount}
                hasOrderActive={hasSchedulingOrder}
              />

              <CardOrdersDelivery
                baskets={readyBasketsSchedulingFiltered}
                loading={loading}
                hasOrderActive={hasSchedulingOrder}
                countOrders={readyBasketsSchedulingFiltered.length}
                headerTitle="PRONTO"
                headerColor="#FF7D24"
                paymentMethods={paymentMethods}
                allPaymentMethods={allPaymentMethods}
                favoritePaymentMethods={favoritePaymentMethods}
                showFinishBills={false}
                hasOrderBy
                hasFilterBy={false}
                getAllOrders={getAllOrders}
                handleItemFinished={handleItemFinished}
                handleCancelItem={handleCancelItem}
                handleUpdate={handleUpdate}
                handleItemReady={handleItemReady}
              />
              <CardOrdersDelivery
                baskets={ongoingBasketsSchedulingFiltered}
                loading={loading}
                hasOrderActive={hasSchedulingOrder}
                countOrders={ongoingBasketsSchedulingFiltered.length}
                headerTitle="EM ROTA"
                headerColor="#01AFFF"
                paymentMethods={paymentMethods}
                allPaymentMethods={allPaymentMethods}
                favoritePaymentMethods={favoritePaymentMethods}
                showFinishBills={false}
                hasOrderBy={false}
                hasFilterBy={false}
                getAllOrders={getAllOrders}
                handleItemFinished={handleItemFinished}
                handleCancelItem={handleCancelItem}
                handleUpdate={handleUpdate}
                handleItemReady={handleItemReady}
              />
              <CardOrdersDelivery
                baskets={deliveredBasketsSchedulingFiltered}
                loading={loading}
                hasOrderActive={hasSchedulingOrder}
                countOrders={deliveredBasketsSchedulingFiltered.length}
                headerTitle="ENTREGUE"
                headerColor="#2EC9B7"
                paymentMethods={paymentMethods}
                allPaymentMethods={allPaymentMethods}
                favoritePaymentMethods={favoritePaymentMethods}
                showFinishBills
                hasOrderBy={false}
                hasFilterBy
                getAllOrders={getAllOrders}
                handleItemFinished={handleItemFinished}
                handleUpdate={handleUpdate}
                handleCancelItem={handleCancelItem}
                handleItemReady={handleItemReady}
              />
            </LugarPedidos>
          ) : (
            <LugarPedidos>
              <CardOrdersSchedulingNew
                handlePrintItem={handlePrintItem}
                handleCancelItem={handleCancelItem}
                baskets={pendingBasketsSchedulingFiltered}
                loading={loading}
                setItemIfoodId={setItemIfoodId}
                handleUpdate={handleUpdate}
                countOrders={pendingBasketSchedulingCount}
                hasOrderActive={hasSchedulingOrder}
              />
              <CardOrdersSchedulingAndamento
                baskets={acceptedBasketsSchedulingFiltered}
                handleItemFinished={handleItemReady}
                handleCancelItem={handleCancelItem}
                loading={loading}
                handleItemReady={handleItemReady}
                handleUpdate={handleUpdate}
                countOrders={acceptedBasketSchedulingCount}
                hasOrderActive={hasSchedulingOrder}
              />
              <CardOrdersSchedulingReady
                baskets={readyBasketsSchedulingFiltered}
                handleItemFinished={handleItemFinished}
                handleCancelItem={handleCancelItem}
                loading={loading}
                getAllOrders={getAllOrders}
                handleUpdate={handleUpdate}
                countOrders={readyBasketSchedulingCount}
                paymentMethods={paymentMethods}
                allPaymentMethods={allPaymentMethods}
                favoritePaymentMethods={favoritePaymentMethods}
                hasOrderActive={hasSchedulingOrder}
              />
            </LugarPedidos>
          )}
        </TabPane>

        <TabPane tabId={2} style={{ height: '100%' }}>
          <LugarPedidos>
            <CardOrdersFinishedDelivery
              baskets={finishedBaskets}
              loading={loading}
              handleCancelItem={handleCancelItem}
              getAllOrders={getAllOrders}
              countOrders={finishedBasketsFiltered.length}
              setFinishedBasketsSession={setFinishedBasketsSession}
              finishedBasketsFiltered={finishedBasketsFiltered}
              finishedBasketsSessionCounter={finishedBasketsSessionCounter}
            />
          </LugarPedidos>
        </TabPane>

        <TabPane tabId={3} style={{ height: '100%' }}>
          <LugarPedidos>
            <CardOrdersCanceled loading={loading} activeTab={activeTab} />
          </LugarPedidos>
        </TabPane>
      </TabContent>
      {planType === 'AI_AGENTS' && <WappAlertDrawer {...wppAlert} />}
    </Wrapper>
  );
}

export default OrdersPage;
